/** @format */

const appConfig = {
  //apiPrefix: "https://dev-api.first-cert.com/",
  wsPrefix: "wss://dev-api.first-cert.com/ws/",
  originUrl: "https://staging-app.first-cert.com/",
  apiPrefix: "firstlinks-api.first-cert.com",
  // wsPrefix: 'ws://localhost:8085/ws/',
  // originUrl: 'http://localhost:5173/',
  authenticatedAdminEntryPath: "/e",
  authenticatedUserEntryPath: "/u",
  unAuthenticatedEntryPath: "/auth/landing",
  claimEntryPath: "/claim",
  tourPath: "/",
  locale: "en",
  enableMock: false,
};

export default appConfig;
